import type { SVGProps } from 'react';

const AppStoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.38 2H17.62C20.0391 2 22 3.96094 22 6.38V17.62C22 20.0391 20.0391 22 17.62 22H6.38C3.96094 22 2 20.0391 2 17.62V6.38C2 3.96094 3.96094 2 6.38 2Z"
      fill="url(#paint0_linear_2193_101962)"
    />
    <path
      d="M8.40952 16.5165L8.4114 16.5171L7.72757 17.7015C7.47796 18.1338 6.92515 18.282 6.4928 18.0323C6.06054 17.7828 5.91233 17.23 6.16194 16.7976L6.66569 15.9251L6.71405 15.8414C6.80038 15.7173 7.01343 15.5031 7.4396 15.5434C7.4396 15.5434 8.44249 15.6522 8.51507 16.1734C8.51507 16.1734 8.52491 16.345 8.40952 16.5166V16.5165ZM18.1082 13.4915H15.9758C15.8306 13.4817 15.7673 13.4298 15.7423 13.3997L15.7407 13.397L13.4581 9.44336L13.4551 9.44532L13.3183 9.24907C13.0939 8.90594 12.7376 9.78344 12.7376 9.78344C12.3123 10.7613 12.798 11.8729 12.9673 12.2089L16.1378 17.7003C16.3873 18.1326 16.9401 18.2808 17.3726 18.0311C17.8048 17.7815 17.953 17.2287 17.7034 16.7963L16.9106 15.4232C16.8952 15.3899 16.8685 15.2996 17.0311 15.2992H18.1082C18.6074 15.2992 19.0121 14.8945 19.0121 14.3953C19.0121 13.8961 18.6074 13.4915 18.1082 13.4915ZM13.9665 14.7202C13.9665 14.7202 14.0803 15.2992 13.6399 15.2992H5.75718C5.25796 15.2992 4.85327 14.8945 4.85327 14.3953C4.85327 13.8961 5.25796 13.4914 5.75718 13.4914H7.78374C8.11093 13.4725 8.18843 13.2836 8.18843 13.2836L8.1903 13.2845L10.8356 8.70266L10.8348 8.7025C10.883 8.61399 10.8429 8.53032 10.8359 8.51711L9.96226 7.00391C9.71265 6.57164 9.86077 6.01875 10.2931 5.76922C10.7255 5.51961 11.2783 5.66766 11.5279 6.1L11.933 6.8018L12.3375 6.10125C12.5871 5.66899 13.1399 5.52079 13.5723 5.77047C14.0046 6.02008 14.1527 6.57282 13.9031 7.00516L10.222 13.3809C10.2059 13.4198 10.201 13.4807 10.3208 13.4914H12.5211L12.5216 13.5129C12.5216 13.5129 13.7933 13.5327 13.9665 14.7202Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2193_101962"
        x1="12"
        y1="2"
        x2="12"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#17C9FB" />
        <stop offset="1" stopColor="#1A74E8" />
      </linearGradient>
      <clipPath id="clip0_2193_101962">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_2193_101962">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

export default AppStoreIcon;
